import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { authenticationRequired } from "@/authentication";
import {
  chileanRoutes,
  adminRoutes,
  development
} from "@/dynamic.routes";
import DashboardRoutesFactoring from "@/router.dashboard.factoring";
import RutasPrivadas from "@/routes/rutas.privadas";
import RutasPublicas from "@/routes/rutas.publicas";
import { EventBus } from "@/main";
import { SelectedCountry, State } from "./configuration";
import { themeService } from "@/services/themeService";

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...RutasPublicas,
    ...RutasPrivadas,
    ...DashboardRoutesFactoring.map(route => {
      route.path = `/panel-facto/${route.path}`;
      route.name = `dashboard-factoring-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/404New.vue")
    },
    {
      path: "*",
      name: "not-found",
      redirect: "/404"
    },
    {
      path: "/mantenimiento",
      name: "mantenimiento",
      component: () => import("@/views/404-mantainNew.vue"),
      // beforeEnter: development
    },
    {
      path: "/estamos-trabajando",
      name: "trabajando",
      component: () => import("@/views/404-working.vue"),
      beforeEnter: development
    },
    

    
    /*  {
      path: "/design-system-redcapital",
      name: "dsrc",
      component: () => import("@/views/designRc/designSystem.vue"),
      beforeEnter: chileanRoutes
    } */ 
  ]
});

/**
 * Guard de acceso por tenant (Enfoque B — whitelist).
 *
 * Si el theme del tenant trae `accessMode === "landing-only"`, SOLO las rutas
 * cuyo `name` esté en LANDING_ONLY_WHITELIST son navegables; cualquier otra
 * (login, registro, panel, etc.) se redirige a /404.
 *
 * Funciona de forma confiable porque el theme ya está cargado cuando corre el
 * primer guard: el $mount está diferido hasta que /theme responde (Fase 47), y
 * si /theme falla se muestra la vista de inconvenientes sin montar (Fase 49).
 *
 * Recordatorio de seguridad: esto bloquea la NAVEGACIÓN (UX). La autorización
 * real la hace el backend validando la capability del tenant en cada endpoint.
 */
const LANDING_ONLY_WHITELIST = [
  "ingreso-claveSii",     // landing clave SII (enviada por correo)
  "enrolamiento-cliente", // landing enrolamiento (enviada por correo)
  "404",
  "not-found",
  "mantenimiento",
  "trabajando"
];

router.beforeEach((to, from, next) => {
  if (themeService.current.accessMode === "landing-only") {
    const name = to.name as string | null;
    const allowed = name != null && LANDING_ONLY_WHITELIST.indexOf(name) !== -1;
    if (!allowed) {
      return next({ name: "404" });
    }
  }
  next();
});

router.afterEach((to, from) => {
  if (State == 2 && to.path != "/mantenimiento") {
    router.push({ path: "/mantenimiento" });
  } else if (State == 3 && to.path != "/estamos-trabajando") {
    router.push({ path: "/estamos-trabajando" });
  }
  store.commit("setRoutes", { to: to.path, from: from.path });
});

const r = router;
// @ts-ignore

function getRoutesList(routes: any, pre: any) {
  return routes.reduce((array: any, route: any) => {
    const path = `${pre}${route.path}`;

    if (route.path !== "*") {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }
    return array;
  }, []);
}

export default router;
